/**
 * POST /encounters/:id/vaccinations (API `VaccinationDto`). RL-982 added the
 * optional `batchNumber`: kept on the vaccination record
 * (`records[].data.batchNumber`) and printed on the certificate
 * (`documents[].data.batch`).
 */
export interface VaccinationRequest {
  vaccine: string;
  dose: string;
  site: string;
  arrivalDate?: string;
  previousReaction: boolean;
  batchNumber?: string;
}

/** API limits for `batchNumber` (trimmed): at most 40 characters. */
export const VACCINE_BATCH_MAX = 40;
/** Same pattern as the API's `VACCINE_BATCH`. */
const VACCINE_BATCH = /^[A-Za-z0-9][A-Za-z0-9 ./-]*$/;

/** Inline message for a batch number the API would refuse; blank is fine. */
export function vaccineBatchError(raw: string): string | undefined {
  const value = raw.trim();
  if (!value) return undefined;
  if (value.length > VACCINE_BATCH_MAX)
    return `Use at most ${VACCINE_BATCH_MAX} characters (now ${value.length}).`;
  if (!VACCINE_BATCH.test(value))
    return 'Use only letters, digits, spaces, ".", "/" and "-", starting with a letter or digit.';
  return undefined;
}
